import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, ListItemText, Menu, MenuItem, useTheme } from '@mui/material';
import { useState } from 'react';

/**
 * Right-click menu matching the grid's ContextMenu look, for non-grid surfaces (cards, tables).
 * Usage: const { openContextMenu, contextMenu } = useContextMenu();
 *        <div onContextMenu={(event) => openContextMenu(event, items)}>…</div> {contextMenu}
 * items: [{ name, icon, action, disabled }]
 */
export const useContextMenu = () => {
  const theme = useTheme();
  const [state, setState] = useState(null);

  const openContextMenu = (event, items) => {
    if (!items || items.length === 0) return;
    event.preventDefault();
    event.stopPropagation();
    setState({ items, position: { left: event.clientX + 2, top: event.clientY - 6 } });
  };

  const close = () => setState(null);

  const contextMenu = (
    <Menu
      open={Boolean(state)}
      onClose={close}
      anchorReference="anchorPosition"
      anchorPosition={state?.position}
      onContextMenu={(event) => {
        event.preventDefault();
        close();
      }}
    >
      {(state?.items ?? []).map((item) => (
        <MenuItem
          key={item.name}
          dense
          disabled={item.disabled}
          onClick={() => {
            close();
            item.action?.();
          }}
        >
          <Box sx={{ mr: 1, width: 20 }}>
            {item.icon && <FontAwesomeIcon icon={item.icon} color={theme.palette.text.primary} fixedWidth />}
          </Box>
          <ListItemText>{item.name}</ListItemText>
        </MenuItem>
      ))}
    </Menu>
  );

  return { openContextMenu, contextMenu };
};
